import { SalesItemType } from '@common/models/Enums';
import { computed, observable } from 'mobx';

export interface ISalesPackageAddOnItem {
  salesItemOptionId: number;
  salesItemId: number;
  salesItemTypeId: number;
  name: string;
  code: string;
  reminderDays: number | null;
  packageAddOnPrice: number | null;
  packageAddOnDisplayPrice: string | number;
  selected: boolean;
  isPackageUpgrade: boolean;
}

export class SalesPackageAddOnItem implements ISalesPackageAddOnItem {
  @observable salesItemOptionId: number;
  @observable salesItemId: number;
  @observable salesItemTypeId: number;
  @observable name: string;
  @observable code: string;
  @observable reminderDays: number | null;
  @observable packageAddOnPrice: number | null;
  @observable isPackageUpgrade: boolean;
  @observable selected: boolean = false;
  constructor(params?: Partial<ISalesPackageAddOnItem>) {
    this.salesItemOptionId = params?.salesItemOptionId ?? 0;
    this.salesItemId = params?.salesItemId ?? 0;
    this.salesItemTypeId = params?.salesItemTypeId ?? 0;
    this.name = params?.name ?? '';
    this.code = params?.code ?? '';
    this.reminderDays = params?.reminderDays ?? null;
    this.packageAddOnPrice = params?.packageAddOnPrice ?? null;
    this.isPackageUpgrade = params?.isPackageUpgrade ?? false;
  }

  @computed get packageAddOnDisplayPrice(): string | number {
    if (this.salesItemTypeId === SalesItemType.CouponDiscountPercentage) {
      if (this.packageAddOnPrice == null) {
        return '';
      }
      const percentValue = this.packageAddOnPrice * 100;
      return (
        new Intl.NumberFormat('en-US', {
          maximumFractionDigits: 1,
          minimumFractionDigits: 1,
        }).format(percentValue) + '%'
      );
    } else {
      if (this.packageAddOnPrice != null) {
        if (this.packageAddOnPrice % 1 !== 0) {
          return `$${this.packageAddOnPrice.toFixed(2)}`;
        } else {
          return `$${this.packageAddOnPrice.toFixed(0)}`;
        }
      }
    }

    return this.packageAddOnPrice ?? '';
  }
}
